import { Form, Link } from "@inertiajs/react";

import TextField from "/components/TextField";
import PasswordField from "/components/TextField/PasswordField";
import Button from "/components/Button";

import styles from "/components/formStyles.module.css";

export default function SignUp({ errors = {} }) {
  return (
    <div className={styles.loginFormWrapper}>
      <Form action="/sign_up" method="POST" className={styles.loginFormContainer}>
        <h1>Sign Up</h1>

        <TextField label="Email" placeholder="email@example.com" name="email" errors={errors.email} />
        <PasswordField label="Password" name="password" errors={errors.password} />

        {errors.base && (
          <ul className="errorsContainer">
            {errors.base.map(errorMessage => (
              <li>{errorMessage}</li>
            ))}
          </ul>
        )}

        <Button type="submit">Sign Up</Button>
      </Form>

      <p className="muted font-small">Already have an account? <Link href="/sign_in">Sign In</Link></p>
    </div>
  );
}
